export const addCustomer = `mutation addCustomer($campaignId: ID!, $data: UserInviteInput!) {
    userInvite(campaignId: $campaignId, data: $data) {
        invitationId,
        errors{
            ... on CampaignDoesNotExistError {
                message
                path
            }
            ... on InvalidFirstName {
                message
                path
            }
            ... on InvalidLastName {
                message
                path
            }
            ... on InvalidPhoneNumber {
                message
                path
            }
            ... on AlreadyInvitedError {
                message
                path
            }
            ... on MissingPhoneNumber {
                message
                path
            }
            ... on MissingEmailError {
                message
                path
            }
        }
    }
  }
  `;

  export const acceptInvitation = `mutation acceptInvitation($invitationId: ID!, $token: String!) {
    userAcceptInvitation(invitationId: $invitationId, token: $token) {
        errors{
            ... on InvitationDoesNotExistError {
                message
            }
            ... on InvitationTokenInvalidError {
                message
            }
            ... on InvitationExpiredError {
                message
            }
            ... on InvitationAlreadyAcceptedError {
                message
            }
        }
    }
  }
  `;